import { create } from 'zustand';

import { SharedRecordTab } from 'components/patient/buildSharedRecordTabs';

type Actions = {
  setTabs: (tabs: SharedRecordTab[], activeLocationEpisodeId: string) => void;
  clear: () => void;
};

type State = {
  tabs: SharedRecordTab[];
  activeLocationEpisodeId: string;
  actions: Actions;
};

export const useSharedRecordTabsStore = create<State>((set) => ({
  tabs: [],
  activeLocationEpisodeId: '',
  actions: {
    setTabs: (tabs, activeLocationEpisodeId) => set({ tabs, activeLocationEpisodeId }),
    clear: () => set({ tabs: [], activeLocationEpisodeId: '' }),
  },
}));

export const useSharedRecordTabsActions = () => useSharedRecordTabsStore((state) => state.actions);
